export default __webpack_public_path__ + "static/media/yesartworksabout.0e8996e2.png";